export default __webpack_public_path__ + "static/media/wavemobile.43ddb3c4.svg";